import React, { useCallback, useEffect, useRef, useState } from 'react'
import Axios from '../../axios-proas';
import { connect } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import * as actions from '../../store/actions/index';
import { useTranslation } from 'react-i18next';
import TableActions from '../../components/UsersManagTable/TableActions/TableActions';
import TableHead from '../../components/UsersManagTable/TableHead/TableHead';
import TableBody from '../../components/UsersManagTable/TableBody/TableBody';
import TableFilters from '../../components/UsersManagTable/TableFilters/TableFilters';
import TablePagination from '../../components/UI/TablePagination/TablePagination';
import TablePagination2 from '../../components/UI/TablePagination/TablePagination2';
import TitleHelmet from '../../components/UI/TitleHelmet/TitleHelmet';
import { checkValidity, getNotyfObject } from '../../shared/utility';
import { useLocation, useParams } from 'react-router-dom';
import { NoContent, SpinnerContainer, Table, TBody } from '../../styles/Table.styled';
import { Header, HeaderActions, HeaderInfos, HeaderLocation, HeaderTitle } from '../../styles/Common';
import { UMBody, UMContainer } from './UsersManagement.styled';
import UserFormModal from '../../containers/UserForm/UserForm'

function UsersManagement(props) {
    let {
        setConfirmationUserModalShow,
        initUserModal,
        userType,   
        loading, 
        usersData, 
        count, 
        currentPage, 
        pageSize,
        setUsersPageSize,
        setUsersPage, 
        getUsersPage, 
        setUsersFilters, 
        filtersQuery, 
        filtering, 
        sortQuery, 
        reverse, 
        setSortQuery, 
        setReverse, 
        updateShowFilters, 
        showFilters,
        selectedUsers,
        selectUserRow,
        unselectUserRow,
        selectedAllRows, 
        selectAllUsersRows,
        emptySelectedUsers,
        setNewUserModal,
        connectedUserId,
        updateUserData
    } = props;
    const {t} = useTranslation();
    let notyf = getNotyfObject();
    let location = useLocation();
    const [showUserModal, setShowUserModal] = useState(false)
    const [isNewUser,setIsNewUser]=useState(true)
    let { uid: entityUid } = useParams();
    const config = {headers: {"X-CSRF": "1",},};
    const [listOfRoles, setListOfRoles] = useState([])
    const [allBailleurs, setAllBailleurs] = useState([])
    const [density, setDensity] = useState("2.25rem")
    const [columns, setColumns] = useState([])
    const [userData, setUserData] = useState({})
    const [userAdminForUserData, setUserAdminForUserData] = useState([])

    const isEmptyFilters = () => {
        const filtersList = columns.map(column => column.field);
        let empty = true;
        filtersList.forEach(filter => {
            if (filtersQuery[filter])
                empty = false;
        })
        return Object.keys(filtersQuery).length === 0 || empty;
    }

    const getListBailleur = () => {
        Axios.get(import.meta.env.VITE_PREFIX_SERVER_API + `Bailleurs`, {
            params: null,

        }).then(res => {
            let temp = res.data.map((item, index) => {
                return { id: item.id, raisonSociale: item.raisonSociale }
            })

            setAllBailleurs(temp)

        })
    }


    useEffect(() => {
        let Object = "usersManager"
            Axios.get(import.meta.env.VITE_PREFIX_SERVER_IDENTITY + 'CreateUsers/configuration/' + connectedUserId + "/" + Object, config).then((response) => {

            if (response?.data?.value) {
                setColumns(JSON.parse(response.data.value))

            } else {
                const columnsCopy = [];
                columnsCopy.push({ title: 'Identifiant', field: 'userName', show: true, width: "14%", alignSelf: "left" });
                columnsCopy.push({ title: 'Prénom et nom', field: 'urn:younov:displayname', show: true, width: "14%", alignSelf: "left" });
                columnsCopy.push({ title: 'Courriel', field: 'email', show: true, width: "14%", alignSelf: "left" });
                columnsCopy.push({ title: 'Téléphone', field: 'phoneNumber', show: true, width: "13%", alignSelf: "left" });
                columnsCopy.push({ title: 'Active', field: 'lockoutEnd', show: true, width: "13%", alignSelf: "left" });
                columnsCopy.push({ title: 'Rôles', field: 'role', show: true, width: "19%", alignSelf: "left" });
                columnsCopy.push({ title: 'Permissions', field: 'permission', show: true, width: "19%", alignSelf: "left" });
                if (userType === "ADMIN_YOUNOV")
                    columnsCopy.push({ title: t("Nom du bailleur"), field: 'BailleurName', width: "16%", show: true, alignSelf: "left" });
               setColumns(columnsCopy);
            }
        })
        return () => {
            selectAllUsersRows(false)
        }
    }, [userType])   
 
    useEffect(() => {
        getListBailleur()
        Axios.get(import.meta.env.VITE_PREFIX_SERVER_IDENTITY +'CreateUsers/getAllRoles', config).then((response) => {
            setListOfRoles(response?.data)
            console
        }).catch(err => {
            console.log(err);
        })

    }, [])

    useEffect(() => {
       // updateShowFilters(false)
        let filtersTemp
        if(entityUid)
            filtersTemp = {
                entityUid,
                claimsType: "bailleur_id",
                connectedUserId

            }
        else
            filtersTemp = {
                entityUid:"000",
                claimsType: "younov",
                connectedUserId
            }
        setUsersFilters(filtersTemp)
        setUsersPage(1)
        getUsersPage(1, filtersTemp, sortQuery, reverse, pageSize);
    }, [getUsersPage, entityUid, pageSize])

    useEffect(() => {
        const isEmpty = isEmptyFilters();
        if(!showFilters && !isEmpty) {
            handleReset()
        }
    }, [showFilters]);
     

    const formatDate = useCallback((date) => {
        if (date !== null && date.valueOf() > 0){
            let newDate = new Date(date);
            let day = newDate.getDate() < 10 ? '0' + newDate.getDate() : newDate.getDate()
            let month = (newDate.getMonth() + 1) < 10 ? '0' + (newDate.getMonth() + 1) : (newDate.getMonth() + 1)
        return day + '/' + month + '/' + newDate.getFullYear()
        }else return null;    
    }, [])

    const handleChangePage = useCallback((newPage) => {
        //e.preventDefault();
        setUsersPage(newPage);
        getUsersPage(newPage, filtersQuery, sortQuery, reverse, pageSize);
    }, [filtersQuery, reverse, sortQuery, pageSize]);

    const handleSort = useCallback((sort,newReverse) => {
        getUsersPage(currentPage, filtersQuery, sort, newReverse, pageSize)
    }, [currentPage,filtersQuery, sortQuery, reverse, pageSize])

    const handleApplyFiltering = useCallback((filters) => {
        getUsersPage(1,filters, sortQuery, reverse, pageSize);
    }, [currentPage, filtersQuery, reverse, sortQuery, pageSize]);

    const handleReset = useCallback(() => {
        //console.log(pageSize)
        let filtersTemp
        if(entityUid)
            filtersTemp = {
                entityUid,
                claimsType: "bailleur_id",
                connectedUserId
            }
        else
            filtersTemp = {
                claimsType: "younov",
                entityUid: "0",
                connectedUserId
            }
        setSortQuery("userName")
        setReverse({ userName: false})
        setUsersFilters(filtersTemp);
        setUsersPage(1);
        emptySelectedUsers()
        getUsersPage(1, filtersTemp, "userName", {first_name: false}, pageSize);
    }, [pageSize])
   
    const enableUser = (userUid) => {
   /*     Axios.put(`user/${userUid}/enableUser`).then(response => {*/
            Axios.put(import.meta.env.VITE_PREFIX_SERVER_IDENTITY + `CreateUsers/enableUser/${userUid}`).then(response => {
                if (response.status == 200) {
                notyf.success(t("default:userAdded", "L'utilisateur a été activé"));
                getUsersPage(currentPage, filtersQuery, sortQuery, reverse, pageSize);
            }
        }).catch(response => {
            notyf.error(t("mandat:generatedErrorMessage", "Une erreur s'est produite"))
        })
    }

    const disableUser = (userUid) => {
        //Axios.put(`user/${userUid}/disableUser`).then(response => {
        Axios.put(import.meta.env.VITE_PREFIX_SERVER_IDENTITY + `CreateUsers/disableUser/${userUid}`).then(response => {
            console.log(response)
            if (response.status==200) {
                notyf.success(t("default:userAdded", "L'utilisateur a été désactivé"));
                getUsersPage(currentPage, filtersQuery, sortQuery, reverse, pageSize);
            }
        }).catch(response => {
            notyf.error(t("mandat:generatedErrorMessage", "Une erreur s'est produite"))
        })
    }

    //function a appeler depuis le body quand on click sur l'icon delete
    const DeleteUser = (userUid) => {
        Axios.delete(import.meta.env.VITE_PREFIX_SERVER_IDENTITY +`CreateUsers/deleteUser/${userUid}`).then(response => {
            if (response) {
                notyf.success(t("default:userAdded", "L'utilisateur a été supprimé"));
                getUsersPage(currentPage, filtersQuery, sortQuery, reverse, pageSize);
              
             
            }
        }).catch(response => {
            notyf.error(t("mandat:generatedErrorMessage", "Une erreur s'est produite"))
        })
    }    

    const getInitUserModal = (userUid) => {
        //const userUid = params?.uid;s   
        Axios.get(import.meta.env.VITE_PREFIX_SERVER_IDENTITY +'CreateUsers/users/' + userUid, config).then((response) => {
            setUserData(response?.data?.userDto);
            updateUserData(response?.data)
       
            setUserAdminForUserData(response?.data?.admins)
            setShowUserModal(true);
        }).catch(err => {
            console.log(err);
        })
    }

    let tBody = null;
    let tSpinner = loading  ? (
        <SpinnerContainer>
            <Spinner animation="border" variant="primary" />
        </SpinnerContainer>
        ) : (
            <NoContent>
                <span>Aucun utilisateur à afficher</span>
            </NoContent>
        )

    if(!loading && usersData?.length > 0){
        tSpinner = null;
        tBody = (
            <TableBody 
                listOfRoles={listOfRoles}
                columns={columns}
                setColumns={setColumns }
                data={usersData ? usersData:[]}
                selectedUsers={selectedUsers}
                selectUserRow={selectUserRow}
                unselectUserRow={unselectUserRow}
                enableUser={enableUser}
                disableUser={disableUser}
                setConfirmationUserModalShow={entityUid ? setConfirmationUserModalShow : setShowUserModal}
                initUserModal={entityUid ? initUserModal : getInitUserModal}
                setNewUserModal={entityUid ? setNewUserModal : setIsNewUser}
                DeleteUser={DeleteUser}
                allBailleurs={allBailleurs}
                userType={userType }
            />
            )
    }
    return (
        <UMContainer>
            {!entityUid &&
                 <Header>
                     <HeaderInfos>
                         <HeaderLocation>{t("menu:entitiesManager", "Gestion des utilisateurs")}</HeaderLocation>
                     </HeaderInfos>
                     <HeaderActions>
                         <TableActions 
                              listOfRoles={listOfRoles}
                                handleReset={handleReset }
                                allBailleurs={allBailleurs}
                                setConfirmationUserModalShow={setShowUserModal}
                                initUserModal={getInitUserModal}
                                setNewUserModal={setIsNewUser} />
                     </HeaderActions>
                 </Header>
                
            }
            <UMBody> 
            
                <TablePagination setDensity={setDensity} columns={columns} setColumns={setColumns}
                    currentPage={currentPage}
                    pageChange={handleChangePage}
                    totalElement={count}
                    perPage={pageSize}
                    perPageChange={setUsersPageSize}
                    saveConfiguration={true}
                    connectedUserId={connectedUserId}
                    title="usersManager"
                /> 
                
                    <Table>
                    <TableHead 
                            setColumns={setColumns }
                            columns={columns} 
                            sortQuery={sortQuery} 
                            reverse={reverse} 
                            setSortQuery={setSortQuery} 
                            setReverse={setReverse} 
                            getData={handleSort}
                            selectedAllRows={selectedAllRows}
                            setSelectedAllRows={selectAllUsersRows}
                            />
                    <TBody height={density}>
                        <TableFilters 
                            setColumns={setColumns}
                            listOfRoles={listOfRoles}
                            columns={columns}
                            entityUid={entityUid}
                            userType={userType}
                            show={showFilters}
                            formatDate={formatDate}
                            filters={filtersQuery}
                            filtersChange={setUsersFilters}
                            applyFilters={handleApplyFiltering}
                            allBailleurs={allBailleurs}
                            handleReset={handleReset}
                                />
                            {tBody}
                        </TBody>            
                    </Table>
                    {tSpinner}
                    <TablePagination
                        currentPage={currentPage} 
                        pageChange={handleChangePage} 
                        totalElement={count} 
                        perPage={pageSize}
                        perPageChange={setUsersPageSize}
                    />	 
                </UMBody>
            <UserFormModal
                show={showUserModal}
                setConfirmationUserModalShow={setShowUserModal}
                title={isNewUser ? "Ajout d'un utilisateur" : "Modification d'un utilisateur"}
                message={``}
                newUserModal={isNewUser}
                contact={isNewUser ? null : userData}
                userAdminForUserData={isNewUser ? null : userAdminForUserData }
                setContact={setUserData}
                listOfRoles={listOfRoles }
                
            />
        </UMContainer>
        
    )
}
const mapStateToProps = (state) => ({
    isAuth : state.auth.token !== null,
    token: state.auth.token,
    loading: state.users.loading,
    usersData : state.users.data,
    count: state.users.count,
    currentPage: state.users.currentPage,
    pageSize: state.users.pageSize,
    filtersQuery: state.users.filtersQuery,
    filtering: state.users.filtering,
    sortQuery: state.users.sortQuery,
    reverse: state.users.reverse,
    selectedUsers: state.users.selectedUsers,
    showFilters: state.users.showFilters,
    selectedAllRows: state.users.selectedAllRows,
    userType: state.auth.userType,
    connectedUserId: state.auth.connectedUserId
})
const mapDispatchToProps = dispatch => ({
    getUsersPage: (page, filters, sort, reverse, pageSize) => dispatch(actions.usersGetPage(page, filters, sort, reverse, pageSize)),
    setUsersPage: (page) => dispatch(actions.usersSetPage(page)),
    setUsersPageSize: (pageSize) => dispatch(actions.usersSetPageSize(pageSize)),
    setUsersFilters: (filters) => dispatch(actions.usersSetFilterQuery(filters)),
    setSortQuery: (sortQ) => dispatch(actions.usersSetSortQuery(sortQ)),
    setReverse: (reverseS) => dispatch(actions.usersSetReverseSort(reverseS)),
    updateShowFilters: (show) => dispatch(actions.usersUpdateShowFilters(show)),
    selectAllUsersRows: (selectAll) => dispatch(actions.setSelectedAllRows(selectAll)),
    selectUserRow: (uid) => dispatch(actions.selectUser(uid)),
    unselectUserRow: (uid) => dispatch(actions.unselectUser(uid)),
    emptySelectedUsers: () => dispatch(actions.emptySelectedUsers()),
    updateUserData: (data) => dispatch(actions.updateUserData(data))
})
export default connect(mapStateToProps, mapDispatchToProps) (UsersManagement) 
